import VueInputTag from './VueInputTag.vue'

export { VueInputTag }

export default VueInputTag
